import React, { useState, useEffect } from 'react';
import NativeTemplates from './NativeTemplates';

import { Button, Modal, Tooltip } from 'antd';

const setProperTemplateBtnText = (translations, isInternal) => {
  if (isInternal) {
    return translations && translations['addtemplate'] ? translations['addtemplate'] : 'Add template';
  }

  return translations && translations['edittemplate'] ? translations['edittemplate'] : 'Edit template';
}

const NativeTemplatesComponent = ({
  state,
  props,
  record,
  childConfig,
  handleVisisbleCancel,
  nativeModalShow,
  native,
}) => {
  const [buttonText, setButtonText] = useState(setProperTemplateBtnText(props.childConfig, props.internal));
  const [fullText, setFullText] = useState(setProperTemplateBtnText(props.childConfig, props.internal));
  const [currentSetTemplate] = useState(
    record && record.text ? JSON.parse(record.text) : false
  );
  const {
    nativeModalVisible,
    templates,
    nativeAdMaterial,
    fieldTranslations,
  } = state;

  const { loadConfig } = props;
  const { translations } = childConfig;
  const formatText = (text) => {
    if (!text) return;
    console.log("button text: ", text)
    if (native && !props.internal) text = translations.nativeTemplate;
    const tempFullText = text;

    setFullText(tempFullText);
    setButtonText(
      tempFullText.length > 20
        ? `${tempFullText.substring(0, 14)}...`
        : tempFullText
    );
  };

  useEffect(() => {
    if (currentSetTemplate && currentSetTemplate.ixTemplateName) {
      formatText(currentSetTemplate.ixTemplateName);
    }
  }, [currentSetTemplate]);

  const updateSelectedTemplateText = (value, key) => {
    formatText(key);
  };

  return (
    <div style={{ display: 'inline-block', marginLeft: '3.5px' }}>
      <Tooltip placement="right" title={fullText}>
        <Button
          type="default"
          size="small"
          onClick={() => nativeModalShow(record.id, record.matspecProps.id)}
          style={{ fontSize: '1em', maxWidth: '120px' }}
        >
          <span
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              display: 'block',
            }}
          >
            {buttonText}
          </span>
        </Button>
      </Tooltip>
      <Modal
        title={
          translations.creativeTemplate
            ? translations.creativeTemplate
            : 'Custom creative template'
        }
        visible={nativeAdMaterial === record.id && nativeModalVisible}
        onCancel={handleVisisbleCancel}
        footer={null}
      >
        <NativeTemplates
          specId={props.specId}
          matSpecId={record.matspecProps.id}
          internal={props.internal}
          templates={templates}
          admaterial={nativeAdMaterial}
          onCancel={handleVisisbleCancel}
          native={native}
          childConfig={{
            ...childConfig,
            loadConfig,
            currentSetTemplate,
            updateSelectedTemplateText,
          }}
        />
      </Modal>
    </div>
  );
};

export default NativeTemplatesComponent;



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/NativeTemplatesComponent.js